import { CountryCode } from '~shared/constants/country-code.enum';

export const UNIFIED_COOKIE_CONSENT_NAME = 'allowedCookieCategories';
export const UNIFIED_COOKIE_DIVIDER = '|';
export const ACCEPT_COOKIES_URL_QUERY = 'itm_pm=cookie_consent_accept_button';
export const COOKIE_BANNER_OVERLAY_CLASS = 'cookie-banner-overlay';
export const COMPASS_COOKIE_DISCLAIMER_CLASS = 'compass-cookie-disclaimer';
export const COMPASS_COOKIE_DISCLAIMER_TAG = 'cms-cookie-disclaimer';
export const COOKIE_ACCEPTED_EVENT = 'cms:cookie-disclaimer:accepted';

export const UNIFIED_COOKIE_VALUE_DEFAULT = {
  [CountryCode.Germany]: ['default', 'necessary', 'functional'],
  [CountryCode.Spain]: ['default', 'necessary'],
  [CountryCode.Italy]: ['default', 'necessary'],
  [CountryCode.Portugal]: ['default', 'necessary'],
  [CountryCode.Netherlands]: ['default', 'necessary'],
  [CountryCode.France]: ['default', 'necessary'],
};
